import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useAuth } from '../../contexts/auth';

import styles from './Login.module.scss';

type LoginForm = {
  email: string;
  password: string;
};
export default function Login() {
  const { login } = useAuth();

  const [errorMessage, setErrorMessage] = useState('');

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginForm>();
  const onSubmit: SubmitHandler<LoginForm> = async (data) => {
    const { email, password } = data;
    try {
      await login(email, password);
    } catch (e: any) {
      setErrorMessage(e.message);
    }
  };

  return (
    <div className={styles.formWrapper}>
      <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        <header className={styles.header}>
          <h1 className='text-center mb-5'>Project OS</h1>
        </header>
        <section className={styles.section}>
          <div className={styles.labelGroup}>
            <input
              {...register('email', { required: true })}
              className='form-control'
              id='inputEmail'
              placeholder='E-mail'
              type='email'
              required
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor='inputEmail'>E-mail</label>
            {errors.email && (
              <div className='text-danger'>Formato inválido</div>
            )}
          </div>

          <div className={styles.labelGroup}>
            <input
              {...register('password', { required: true })}
              className='form-control'
              id='inputPassword'
              placeholder='Senha'
              type='password'
              required
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor='inputPassword'>Senha</label>
            {errors.password && (
              <div className='form-text text-danger'>Formato inválido</div>
            )}
          </div>
        </section>
        <footer className='d-grid gap-1 text-center'>
          <button type='submit' className='btn btn-dark btn-lg'>
            Entrar
          </button>
          <div className='form-text text-danger'>
            {errorMessage || <>&nbsp;</>}
          </div>
        </footer>
      </form>
    </div>
  );
}
